import { API_BASE_URL, apiGet, apiPut } from './api-utils';
import {
    IAccountShippingPreferences,
    IShippingPreference,
} from '../models/shipping-preferences';
import { IResult } from '../models/result-models';

const baseUrl = API_BASE_URL + '/v1/accounts/shipping-preferences';

export const getShippingPreferences = async (): Promise<
    IResult<IAccountShippingPreferences[]>
> => {
    const result = await apiGet<IAccountShippingPreferences[]>(baseUrl);
    return result;
};

export const getDefaultShippingPreferences = async (
    billTo: string,
    shipTo?: string
): Promise<IResult<IAccountShippingPreferences>> => {
    const url = `${baseUrl}/billTo/${billTo}/shipTo/${shipTo}`;
    const result = await apiGet<IAccountShippingPreferences>(url);
    return result;
};

export const saveShippingPreferences = async (
    preferences: IShippingPreference
): Promise<IResult<boolean>> => {
    const result = apiPut<IShippingPreference, boolean>(baseUrl, preferences);

    return result;
};
